export class Base64 {
    static _toBinary(string) {
        const codeUnits = Uint16Array.from({ length: string.length }, (element, index) => string.charCodeAt(index));
        const charCodes = new Uint8Array(codeUnits.buffer);
        let result = "";
        charCodes.forEach((char) => {
            result += String.fromCharCode(char);
        });
        return result;
    }
    static _fromBinary(binary) {
        const bytes = Uint8Array.from({ length: binary.length }, (element, index) => binary.charCodeAt(index));
        const charCodes = new Uint16Array(bytes.buffer);
        let result = "";
        charCodes.forEach((char) => {
            result += String.fromCharCode(char);
        });
        return result;
    }
    static encode(input) {
        const converted = Base64._toBinary(input);
        return window.btoa(converted);
    }
    static decode(input) {
        const decoded = window.atob(input);
        return Base64._fromBinary(decoded);
    }
}
